import 'zone.js';
import { bootstrapApplication } from '@angular/platform-browser';
import { AppComponent } from './app/app';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideHttpClient, withFetch } from '@angular/common/http';
import { provideAnimations } from '@angular/platform-browser/animations';
import { importProvidersFrom } from '@angular/core';
import { routes } from './app/app-routing.module';
import {
  LucideAngularModule,
  Star,
  Sparkles,
  Heart,
  Bookmark,
  Ellipsis,
  ListPlus,
  List,
  CircleX,
  ChevronLeft,
  ChevronRight,
  CalendarFold
} from 'lucide-angular';

const appIcons = {
  Star,
  Sparkles,
  Heart,
  Bookmark,
  Ellipsis,
  ListPlus,
  List,
  CircleX,
  ChevronLeft,
  ChevronRight,
  CalendarFold
};

bootstrapApplication(AppComponent, {
  providers: [
    provideAnimations(),
    provideRouter(
      routes,
      withInMemoryScrolling({
        scrollPositionRestoration: 'top',
        anchorScrolling: 'enabled'
      })
    ),
    // provideClientHydration(),
    provideHttpClient(withFetch()),
    importProvidersFrom(LucideAngularModule.pick(appIcons)),
  ],
}).catch((error) => console.error(error));
